import * as React from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { CssBaseline, withStyles } from '@material-ui/core';
import { RouteComponentProps } from 'react-router';
import { EditVideo } from '../TelestrationsVideoLibrary/Components/EditVideo';
import { flow } from 'fp-ts/lib/function';
import { ILocalStateMgr, withLocalState } from '../../App/LocalState';
import { LeftSideMenu } from 'src/App/Components/LeftSideMenu';
import { DownloadUploadFiles } from '../../App/Components/DownloadUploadFiles';

const drawerWidth = 240;

const styles = () => ({
    message: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        height: '100vh',
    },
    content: {
        marginLeft: drawerWidth,
        display: 'flex',
        height: '100vh',
        transition: 'margin-left 0.5s ease-out',
        '&.maxWidth': {
            marginLeft: '72px',
        },
        '&::after': {
            content: '""',
            background: `url(${require('../../Assets/keyframe_logo.png')}) no-repeat`,
            backgroundSize: '100vw 100vh',
            opacity: 0.03,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            zIndex: -1,
        },
    },
});

interface ITelestrationRoutesProps extends Partial<RouteComponentProps<any>> {
    classes?: any;
    skipSaveToServer?: boolean;
    localStateMgr: ILocalStateMgr;
    license?: boolean;
}
const telestrationRoutes = ({
    classes,
    localStateMgr: { state, dispatch },
    license,
}: ITelestrationRoutesProps) => {
    const history = useHistory();
    const videoID = history;
    const loading = false;
    const error = false;

    const fixedEncodeURIComponent = (str: string) => {
        return decodeURIComponent(str).replace(/[!'()*]/g, (c) => {
            return '%' + c.charCodeAt(0).toString(16);
        });
    };

    return (
        <Route
            render={(RouterProps) =>
                loading ? (
                    <div className={classes.message}>Loading...</div>
                ) : !error ? (
                    <div>
                        <DownloadUploadFiles />
                        <CssBaseline />
                        <LeftSideMenu
                            open={state.leftSideMenuOpen}
                            onToggle={() =>
                                dispatch({ type: 'ON_TOGGLE_LEFT_SIDE_MENU' })
                            }
                            isUserSubscribed={true}
                        />
                        <div
                            className={`${classes.content} ${
                                state.leftSideMenuOpen || 'maxWidth'
                            }`}
                        >
                            <EditVideo
                                withMarginLeft={true}
                                videoUrl={fixedEncodeURIComponent(
                                    videoID.location.search.split('=')[1]
                                )}
                                license={license}
                            />
                        </div>
                    </div>
                ) : (
                    <Redirect to='/404' />
                )
            }
        />
    );
};

export const TelestrationRoutes = flow(
    withLocalState,
    withStyles(styles)
)(telestrationRoutes);
